module.exports = __webpack_public_path__ + "img/c-img-2.cf53c000.jpg";